import React from "react";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { LanguageConstants } from "../../constants/LanguageConstants";

/** Strip non-digits for react-phone-input-2 `value` (full international number without `+`). */
export function mergeDialCodeAndNational(countryCodeField: string | undefined, nationalNumber: string | undefined): string {
  const cc = String(countryCodeField ?? "").replace(/\D/g, "");
  const nat = String(nationalNumber ?? "").replace(/\D/g, "");
  return `${cc}${nat}`;
}

const CommanPhoneNumber = ({
  value,
  nationalNumber,
  handleMobileNumber,
  hideLabel,
  splitInput = true,
}: any) => {
    // const handlePhone = (value: any, code: any) => {
    //     const regex = new RegExp(code?.dialCode)
    //     const phone = value.replace(regex, "");
    //     handleMobileNumber(value, code, phone)
    // }
    const handlePhone = (value: string, code: any) => {
        const dialCode = code?.dialCode || "";

        const phone = value.startsWith(dialCode)
            ? value.slice(dialCode.length)
            : value;

        handleMobileNumber(dialCode, phone);
    };

    /**
     * Profile/Signup use a split layout: flag + dial live in PhoneInput, digits in `.wrap-phn-input`.
     * Feeding the merged full number into PhoneInput duplicates the national portion under the overlay.
     */
    const dialDigits = String(value ?? "").replace(/\D/g, "");
    const phoneInputValue = splitInput
      ? dialDigits
      : mergeDialCodeAndNational(value, nationalNumber);

    return (
        <>
            <div className={`${hideLabel ? 'com-mobile-input' : ' com-floating'}${hideLabel ? ' com-mobile-input--hide-label' : ''}`}>
                {!hideLabel ? (
                <label className="mobile-label f-label">{LanguageConstants?.PHONE_NUMBER}</label>
                ) : null}
                
                <PhoneInput
                    inputClass="f-input w-100"
                    specialLabel=""
                    placeholder=""
                    disableInitialCountryGuess={false}
                    enableLongNumbers={false}
                    country={"us"}
                    countryCodeEditable={false}
                    value={phoneInputValue}
                    onChange={handlePhone}
                    inputProps={{
                         disabled: splitInput,
                     }}
                />
                {/* <input className="mobile-label" type="text" /> */}
            </div>
        </>
    )
}

export default CommanPhoneNumber;
